export const getCookie = (name: string, cookie: string): string | null => {
  const prefix = `${name}=`;
  const cookieValue = cookie
    .split('; ')
    .find((row) => row.startsWith(prefix))
    ?.split('=')[1];
  return cookieValue ? decodeURI(cookieValue) : null;
};
